export default "__VITE_ASSET__2f7d4f6f__"